<app-content-loading *ngIf="isLoading"></app-content-loading>

@if (analysis && !isLoading)
{
<div class="row">
  <div class="col-12 col-shrink">
    <section>
      <!-- <div class="card card-sm mb-3">
        <div class="card-header">
          <h5 class="card-title">
            {{ texts.potentialAnalysis | localize }}
          </h5>
        </div>
        <div class="card-body">           -->

      <!-- a new analysis was asked for: this one stays until it's replaced -->
      @if (analysisRequested) {
      <div class="card mb-5">
        <div class="card-body">
          <p class="mb-0 text-muted">
            <i class="fa-sharp fa-solid fa-circle-info me-2"></i> {{ texts.newAnalysisRequested | localize }}
          </p>
        </div>
      </div>
      }

      <div class="row mb-n3">
        <div class="col-12 col-md-4 mb-3">
          <app-kpi-card [label]="texts.perfectMatches | localize" [clickable]="true"
            (click)="perfectMatchesModal.show()">
            {{ analysis?.EstimatedTotalMatches | number:'1.0-0' }}
          </app-kpi-card>
        </div>

        <div class="col-12 col-md-4 mb-3">
          <app-kpi-card [label]="texts.hiddenTalents | localize" [clickable]="true" (click)="hiddenTalentsModal.show()">
            {{ analysis?.LikelyMatchCount * .5 | number : '0.0-0' }}
          </app-kpi-card>
        </div>

        <div class="col-12 col-md-4 mb-3">
          <app-kpi-card [label]="texts.additionalPotential | localize" [clickable]="true"
            (click)="potentialAnalysisModal.show()">
            {{ analysis?.NearMatchCount | number : '0.0-0' }}
          </app-kpi-card>
        </div>
      </div>

      @if (demo.isActive) {
      <div class="card card-clickable mt-4" [routerLink]="['/projects', project.Id]" [queryParams]="{ view: 'pool' }">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col">
              <p class="fw-bold mb-0"><i class="fa-sharp fa-solid fa-users me-2"></i> {{ poolMatches.length }} {{
                texts.poolMatches | localize }}</p>
            </div>
            <div class="col-auto">
              <sc-avatar-list [users]="poolMatches"></sc-avatar-list>
            </div>
            <div class="col-auto text-muted ps-0">
              <i class="fa-regular fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
      }

      <!-- 
      <div class="row">
        <div class="col-6">
          <div class="card mt-5">
            <div class="card-header">
              <h5 class="card-title">
                Wie viel Berufserfahrung bringen passende Talente mit?
              </h5>
            </div>
            <div class="card-body">
              <div class="chart-container">
                <canvas id="experienceChart"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card mt-5">
            <div class="card-header">
              <h5 class="card-title">
                Wo befinden sich passende Talente?
              </h5>
            </div>
            <div class="card-body">
              <div class="map-container">
                <sc-map-marker-radius [locations]="mapLocations"></sc-map-marker-radius>
              </div>
            </div>
          </div>
        </div>
      </div> -->



      <!-- 
        </div>
      </div> -->

      <!-- <app-notification class="mt-3" [ctaLabel]="texts.reviewTalentsCta | localize"
        [routerLink]="['/projects', project.Id]" [queryParams]="{ view: 'ident' }">
        {{ texts.reviewTalents | localize }}
      </app-notification> -->

      <div class="card mt-4">
        <div class="card-header">
          <h5 class="card-title">
            {{ texts.reachQuestion | localize }}
          </h5>
        </div>

        <div class="card-body card-body-list">
          <div class="list-group ">
            <div class="list-group-item border-primary bg-primary-lightest skillconomy-highlighted">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div
                    class="rounded-circle d-inline-flex align-items-center justify-content-center text-white fw-bold skillconomy">
                    <img src="assets/icons/sc-icon.svg">
                  </div>
                </div>
                <div class="col col-shrink">
                  <p class="mb-0">skillconomy</p>
                  <span class="small fw-normal text-muted mb-0 oneline d-inline-block">{{ texts.scMatching | localize
                    }}</span>
                </div>
                <div class="col-12 col-sm-auto mt-4 mt-sm-0 text-end">
                  <p class="h4 mb-0">{{ analysis.EstimatedTotalMatches }}</p>
                  <p class="small mb-0 ">{{ texts.talentsLabel | localize }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="rounded-circle align-items-center justify-content-center fw-bold linkedin">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
                      <path
                        d="M196.3 512L103.4 512L103.4 212.9L196.3 212.9L196.3 512zM149.8 172.1C120.1 172.1 96 147.5 96 117.8C96 103.5 101.7 89.9 111.8 79.8C121.9 69.7 135.6 64 149.8 64C164 64 177.7 69.7 187.8 79.8C197.9 89.9 203.6 103.6 203.6 117.8C203.6 147.5 179.5 172.1 149.8 172.1zM543.9 512L451.2 512L451.2 366.4C451.2 331.7 450.5 287.2 402.9 287.2C354.6 287.2 347.2 324.9 347.2 363.9L347.2 512L254.4 512L254.4 212.9L343.5 212.9L343.5 253.7L344.8 253.7C357.2 230.2 387.5 205.4 432.7 205.4C526.7 205.4 544 267.3 544 347.7L544 512L543.9 512z" />
                    </svg>
                  </div>
                </div>
                <div class="col col-shrink">
                  <p class="mb-0">LinkedIn Recruiter</p>
                  <span class="small fw-normal text-muted mb-0 oneline d-inline-block">{{ texts.booleanSearch | localize
                    }}</span>
                </div>
                <div class="col-12 col-sm-auto mt-4 mt-sm-0 text-end">
                  <p class="h4 mb-0">{{ analysis.TotalLinkedInReachable }}</p>
                  <p class="small mb-0 ">{{ texts.talentsLabel | localize }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="rounded-circle align-items-center justify-content-center text-white fw-bold xing">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
                      <path
                        d="M290.7 274C288.9 277.3 265.5 318.4 220.6 397.5C215.7 405.8 209.8 410 202.9 410L137.8 410C130.1 410 125.7 402.5 129.3 395.6L198.3 274.3C198.5 274.3 198.5 274.2 198.3 274L154.4 198.4C150.1 190.6 154.7 184.3 162.9 184.3L228 184.3C235.3 184.3 241.3 188.4 246 196.5L290.7 274zM510.6 110.1L366.6 363.1L366.6 363.4L458.2 530C462.1 537.1 458.4 544.1 449.7 544.1L384.5 544.1C376.9 544.1 370.9 540.1 366.5 531.9L274.1 363.4C277.4 357.6 325.6 272.6 418.9 108.2C423.5 100.1 429.3 96 436.4 96L502.1 96C510.1 96 514.4 102.7 510.6 110.1z" />
                    </svg>
                  </div>
                </div>
                <div class="col col-shrink">
                  <p class="mb-0">XING Talentmanager</p>
                  <span class="small fw-normal text-muted mb-0 oneline d-inline-block">{{ texts.booleanSearch | localize
                    }}</span>
                </div>
                <div class="col-12 col-sm-auto mt-4 mt-sm-0 text-end">
                  <p class="h4 mb-0">{{ analysis.TotalXingReachable }}</p>
                  <p class="small mb-0 ">{{ texts.talentsLabel | localize }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="rounded-circle align-items-center justify-content-center text-white fw-bold posting">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
                      <path
                        d="M96 128C96 110.3 110.3 96 128 96C357.8 96 544 282.2 544 512C544 529.7 529.7 544 512 544C494.3 544 480 529.7 480 512C480 317.6 322.4 160 128 160C110.3 160 96 145.7 96 128zM96 480C96 444.7 124.7 416 160 416C195.3 416 224 444.7 224 480C224 515.3 195.3 544 160 544C124.7 544 96 515.3 96 480zM128 224C287.1 224 416 352.9 416 512C416 529.7 401.7 544 384 544C366.3 544 352 529.7 352 512C352 388.3 251.7 288 128 288C110.3 288 96 273.7 96 256C96 238.3 110.3 224 128 224z" />
                    </svg>
                  </div>
                </div>
                <div class="col col-shrink">
                  <p class="mb-0">{{ texts.jobBoards | localize }}</p>
                  <span class="small fw-normal text-muted mb-0 oneline d-inline-block">{{ texts.activelySearching |
                    localize
                    }}</span>
                </div>
                <div class="col-12 col-sm-auto mt-4 mt-sm-0 text-end">
                  <p class="h4 mb-0">{{ analysis.TotalJobBoardsReachable }}</p>
                  <p class="small mb-0 ">{{ texts.talentsLabel | localize }}</p>
                </div>
              </div>
            </div>

            <!-- <div class="list-group-item list-group-item-action">
            <div class="row align-items-center">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-dark" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
                    class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
              </div>
            </div>
          </div> -->

          </div>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-header">
          <h5 class="card-title">
            {{ texts.employersQuestion | localize }}
          </h5>
        </div>

        <div class="card-body card-body-list">
          <div class="list-group ">

            @for (c of analysis.Companies; track c)
            {
            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col-auto">

                  <div class="company-logo">
                    <i class="fa-sharp fa-solid fa-building text-muted"></i>
                  </div>
                </div>
                <div class="col col-shrink">
                  <p class="mb-0">
                    {{ c.Name }}
                    <span class="badge badge-pill ms-2" [ngClass]="ratingBadge(scoreRating(company))">
                      <i class="fa-sharp fa-solid me-1" [class.fa-arrow-up]="scoreRating(company) == 'good'"
                        [class.fa-arrow-right]="scoreRating(company) == 'neutral'"
                        [class.fa-arrow-down]="scoreRating(company) == 'bad'"></i>
                      @if (scoreRating(company) == 'good') { höhere Attraktivität }
                      @else if (scoreRating(company) == 'neutral') { ähnliche Attraktivität }
                      @else { unterdurchschn. }
                    </span>
                  </p>
                  <span class="small fw-normal text-muted mb-0 oneline d-inline-block">
                    {{ c.MainLocation}} <span *ngIf="c.TotalLocations > 1">+ {{ c.TotalLocations - 1}} Standorte</span>
                  </span>
                </div>
                <div class="col-12 col-sm-auto mt-4 mt-sm-0 text-end">
                  <p class="h4 mb-0">{{ c.MatchShare | number: '0.1-1' }}%</p>
                  <p class="small mb-0 ">{{ texts.talentsLabel | localize }}</p>
                </div>
              </div>
            </div>
            }

            <!-- <div class="list-group-item list-group-item-action">
            <div class="row align-items-center">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-dark" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
                    class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
              </div>
            </div>
          </div> -->

          </div>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-header">
          <h5 class="card-title">
            {{ texts.moreCandidatesQuestion | localize }}
          </h5>
        </div>
        <!-- <div class="card-body">
        <p class="m-0 p-0">
          {{ texts.moreCandidatesBody | localize }}
        </p>
      </div> -->
        <div class="card-body card-body-list">
          <div class="list-group ">
            @for (c of analysis.Stats; track c)
            {
            @if(c.Requirement.Type == 'Skill' && c.Requirement.Priority == 'MustHave' && c.LikelyGainRate > 0)
            {
            <div class="list-group-item">
              <div class="row align-items-center">

                <div class="col col-shrink">
                  <p class="mb-0">
                    {{c.Requirement | requirementLabel}}
                    <!-- <span class="badge badge-pill ms-2" [ngClass]="ratingBadge(scoreRating(company))">
                              <i class="fa-sharp fa-solid me-1"
                                [class.fa-arrow-up]="scoreRating(company) == 'good'"
                                [class.fa-arrow-right]="scoreRating(company) == 'neutral'"
                                [class.fa-arrow-down]="scoreRating(company) == 'bad'"></i>
                              @if (scoreRating(company) == 'good') { höhere Attraktivität }
                              @else if (scoreRating(company) == 'neutral') { ähnliche Attraktivität }
                              @else { unterdurchschn. }
                            </span> -->
                  </p>
                  <span class="small fw-normal text-muted mb-0 oneline d-inline-block">
                    {{ c.RelaxDescription }}
                  </span>
                </div>
                <div class="col-12 col-sm-auto mt-4 mt-sm-0 text-end">
                  <p class="h4 mb-0">{{ c.LikelyGainRate | number: '0.1-1' }}%</p>
                  <p class="small mb-0 fw-normal">{{ texts.talentsLabel | localize }}</p>
                </div>
              </div>
            </div>
            }
            }

            <!-- <div class="list-group-item list-group-item-action">
            <div class="row align-items-center">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-dark" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
                    class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
              </div>
            </div>
          </div> -->

          </div>
        </div>
      </div>

      <div class="card mt-4" *ngIf="candidates?.length">

        <div class="card-header">

          <div class="row">
            <div class="col">
              <h5 class="card-title">
                {{ texts.referenceProfiles | localize }}
              </h5>
            </div>
          </div>

        </div>

        <div class="card-body card-body-list">
          <div class="list-group ">
            <a class="list-group-item list-group-item-action" (click)="showReview(i)"
              *ngFor="let candidate of candidates; let i = index">

              <div class="row flex-sm-nowrap align-items-center">

                <div class="col-12 col-sm-auto mb-0 mb-sm-0">
                  <sc-avatar [user]="candidate" size="sm"></sc-avatar>
                </div>

                <div class="col col-shrink ms-n2">

                  <div class="row">

                    <div class="col col-shrink">

                      <div class="align-items-center d-flex">

                        <p class="d-inline-block fw-bold mb-0 me-3">{{ candidate.FirstName }} {{
                          candidate.LastName }}
                        </p>
                        <!-- <span class="d-none d-sm-inline-block badge badge-pill badge-success-soft"
                          style="transform: translateY(-.4rem);">
                          {{ texts.perfectMatchBadge | localize }}
                        </span> -->
                      </div>

                      <p class="small text-muted job-title mb-0 fw-normal oneline">{{ candidate.JobTitle }}</p>

                    </div>

                    <!-- <div class="col-12">
                      <ul class="tag-list list-inline mb-n1 mt-1" *ngIf="candidate.Skills">
                        <li class="list-inline-item mb-1 me-1" *ngFor="let tag of candidate.Skills, let i = index;">
                          <span class="tag tag-clip-text small">
                            {{tag}}
                          </span>
                        </li>
                      </ul>
                    </div> -->

                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                  <button class="btn btn-secondary btn-sm">Passt nicht?</button>
                </div>
              </div> -->

            </a>
            <!-- <div class="list-group-item list-group-item-action">
                  <div class="row align-items-center">
                    <div class="col d-flex justify-content-end">
                      <button class="btn btn-dark" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
                          class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
                    </div>
                  </div>
                </div> -->
          </div>
        </div>

        @if (canReview()) {
        <div class="card-footer">
          <div class="row">
            <div class="col"></div>
            <div class="col-auto">
              <button class="btn btn-secondary" (click)="showReview()">Feedback geben</button>
              <button class="btn btn-dark ms-2" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
                  class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
            </div>
          </div>
        </div>
        }
      </div>

    </section>
  </div>
  <!-- <div class="col-3 d-none d-xl-block">
    <div class="card analysis-nav" appFixedColumn>
      <div class="card-body card-body-list">
        <ul class="list-group fw-bold text-muted small">
          <li class="list-group-item list-group-item-action py-2 px-4">
            <i class="fa-sharp fa-solid fa-arrow-right fa-xs me-2"></i> Kanäle
          </li>
          <li class="list-group-item list-group-item-action py-2 px-4">
            <i class="fa-sharp fa-solid fa-arrow-right fa-xs me-2"></i> Arbeitgeber
          </li>
          <li class="list-group-item list-group-item-action py-2 px-4">
            <i class="fa-sharp fa-solid fa-arrow-right fa-xs me-2"></i> Talente
          </li>
          <li class="list-group-item list-group-item-action py-2 px-4">
            <i class="fa-sharp fa-solid fa-arrow-right fa-xs me-2"></i> Anforderungen
          </li>
        </ul>
      </div>
    </div>
  </div> -->
</div>

}


@if (!analysis && !isLoading)
{
@if (!analysisRequested)
{
<div class="card card-xl">
  <div class="card-body">
    <h4 class="mb-5">{{ texts.requestAnalysisPrompt | localize }}</h4>
    <p class="fw-normal mb-4">{{ texts.requestAnalysisBody | localize }}</p>
    <ul class="list-unstyled mb-5">
      @for (benefit of texts.requestAnalysisBenefits; track benefit) {
      <li class="mb-1">
        <i class="fa-sharp fa-solid fa-check text-success me-3"></i>{{ benefit | localize }}
      </li>
      }
    </ul>
    <div class="d-flex flex-wrap align-items-center">
      <button class="btn btn-dark me-4" (click)="requestAnalysisModal.show(project)">
        {{ texts.requestAnalysisFree | localize }}
      </button>
    </div>
  </div>
</div>
}
@else
{
<div class="card card-xl">
  <div class="card-body">
    <h4>{{ texts.analysisInProgress | localize }}</h4>
    <p class="fw-normal mb-5">{{ texts.analysisInProgressBody | localize }}</p>
    <div class="d-flex flex-wrap align-items-center">
      <button class="btn btn-dark me-4" (click)="startModal.show(project)">
        {{ texts.startOutreach | localize }}
      </button>
    </div>
  </div>
</div>
}
}

<sc-modal #requirementModal>
  <sc-modal-header>
    @if (selectedRequirement)
    {
    <span class="d-inline-block oneline">{{ formatRequirementLabel(selectedRequirement.Requirement) }}</span>
    }
  </sc-modal-header>
  <sc-modal-body>
    <p>
      {{ selectedRequirement?.Description }}
    </p>
  </sc-modal-body>
  <sc-modal-footer>
    <button class="btn btn-dark" (click)="requirementModal.dismiss()">{{ texts.ok | localize }}</button>
  </sc-modal-footer>
</sc-modal>

<sc-modal size="md" #perfectMatchesModal>
  <sc-modal-header>
    {{ texts.perfectMatches | localize }}
  </sc-modal-header>
  <sc-modal-body>
    <div class="p-3">
      <p class="mb-0">
        <i>{{ texts.perfectMatches | localize }}</i> {{ texts.perfectMatchesModalBody | localize }} {{
        analysis?.PerfectMatchDescription }}
      </p>
    </div>
  </sc-modal-body>
</sc-modal>

<sc-modal #hiddenTalentsModal>
  <sc-modal-header>
    {{ texts.hiddenTalents | localize }}
  </sc-modal-header>
  <sc-modal-body>
    <div class="p-3">
      <p class="mb-0">
        {{ texts.hiddenTalentsModalBody | localize }} <i>{{ texts.hiddenTalents | localize }}</i> {{
        texts.hiddenTalentsModalBodyAfter | localize }} {{
        analysis?.LikelyMatchDescription }}
      </p>
    </div>
  </sc-modal-body>
</sc-modal>

<sc-modal #potentialAnalysisModal>
  <sc-modal-header>
    {{ texts.additionalPotential | localize }}
  </sc-modal-header>
  <sc-modal-body>
    <div class="p-3">
      <p class="mb-0">
        {{ texts.additionalPotentialModalBodyBefore | localize }} <i>{{ texts.perfectMatches | localize }}</i> {{
        texts.additionalPotentialModalBody | localize }} {{ analysis?.NearMatchDescription }}
      </p>
    </div>
  </sc-modal-body>
</sc-modal>

<sc-modal #editRequirementsModal>
  <sc-modal-header>
    {{ texts.editRequirementsTitle | localize }}
  </sc-modal-header>

  <sc-modal-body>
    <p>
      {{ texts.editRequirementsBody | localize }}
    </p>
  </sc-modal-body>

  <sc-modal-footer>
    <button class="btn btn-secondary" (click)="editRequirementsModal.dismiss()">{{ texts.cancel | localize }}</button>
    <button class="btn btn-dark" (click)="editRequirements = true;editRequirementsModal.dismiss();">{{ texts.ok |
      localize }}</button>
  </sc-modal-footer>

</sc-modal>


<app-modal-start-project #startModal [language]="loc.language"></app-modal-start-project>

<app-modal-request-analysis #requestAnalysisModal [language]="loc.language"
  (requested)="project.Status = 'AnalysisRequested'"></app-modal-request-analysis>

<sc-modal-wizard #reviewModal size="xl">

  <sc-modal-header>
    <div>{{ texts.reviewTitle | localize }}</div>
  </sc-modal-header>

  <sc-modal-wizard-page *ngFor="let candidate of candidates; let i = index; let isFirst = first; let isLast = last">

    <sc-modal-body customClasses="p-0 d-flex flex-column">

      <!-- the modal focuses the first focusable element it finds when it opens, which
           would leave a focus ring on the first profile link -->
      <div ngbAutofocus tabindex="-1" class="focus-sink"></div>


      <div class="row review-columns">
        <div class="col-8 scrollbar-minimal">

          <!-- every profile has its own page, so they render one after the other (see showReview) -->
          @if (candidate.isVisible) {
          <div>
            <div *ngIf="candidate">

              <div class="row align-items-start">

                <div class="col col-shrink pl-4">
                  <p class="mb-2 fw-bold">
                    <i class="me-2 fa-sharp fa-solid fa-user"></i>{{ candidate.FirstName }} {{ candidate.LastName }}
                  </p>

                  <p class="mb-2" *ngIf="candidate.JobTitle">
                    <i class="me-2 fa-sharp fa-solid fa-briefcase"></i>{{ candidate.JobTitle }}
                  </p>

                  <p class="mb-2" *ngIf="candidate.Company">
                    <i class="me-2 fa-sharp fa-solid fa-building"></i>{{ candidate.Company }}
                  </p>

                  <p class="mb-2" *ngIf="candidate.City">
                    <i class="me-2 fa-sharp fa-solid fa-location-dot"></i>{{ candidate.City }}
                  </p>

                  <p class="mb-2" *ngIf="candidate.XingUri">
                    <fa class="fa-brands fa-square-xing me-2"></fa> <a [href]="candidate.XingUri" target="_blank">{{
                      candidate.XingUri }}</a>
                  </p>

                  <p class="mb-2" *ngIf="candidate.LinkedInUri">
                    <fa class="fa-brands fa-linkedin me-2"></fa> <a [href]="candidate.LinkedInUri" target="_blank">{{
                      candidate.LinkedInUri }}</a>
                  </p>
                </div>

                <div class="col-auto">
                  <div class="avatar-container">
                    <sc-avatar size="xl" [user]="candidate"></sc-avatar>
                  </div>
                </div>

                <div class="col-12">
                  <hr>
                </div>
              </div>

            </div>

            <div *ngIf="candidate?.Screening?.RequirementResults?.length">
              <div class="pretitle mt-4 mb-1">Analyse</div>
              <app-candidate-analysis class="d-block" [candidate]="candidate"></app-candidate-analysis>
            </div>

            <app-candidate-skills class="d-block mt-4" [candidate]="candidate"></app-candidate-skills>
            <app-candidate-experience class="d-block mt-4" [candidate]="candidate"></app-candidate-experience>
            <app-candidate-education class="d-block mt-4" [candidate]="candidate"></app-candidate-education>
          </div>
          }
        </div>
        <div class="col-4 bg-neutral-lighter scrollbar-none">
          @if (candidate.isVisible) {

          @if(canReview())
          {          
          <div class="mb-4">
            <div class="form-group mb-0">
              <div class="row">
                <div class="col-12">
                  <!-- the field is the container, the textarea and the send button sit inside it -->
                  <div class="form-control comment-input">
                    <autosize-textarea [(text)]="candidate.commentInput"
                      (textChange)="removeError(candidate)"
                      [placeholder]="(feed.mentionItems?.length ? texts.feedMentionPlaceholder : texts.feedCommentPlaceholder) | localize"
                      [mentionable]="feed.mentionItems"></autosize-textarea>
                    <button class="btn btn-dark btn-sm btn-circle me-2"
                      [disabled]="candidate.isSendingComment || !candidate.commentInput"
                      (click)="submitComment(candidate, feed)">
                      <i class="fa-sharp fa-regular fa-paper-plane"></i>
                    </button>
                  </div>
                </div>
                @if (candidate.isCommentRequired) {
                <div class="col-12 mt-3">
                  <div class="alert alert-error comment-alert mb-0" role="alert">
                    <p class="alert-heading mb-0">
                      <i class="fa-sharp fa-solid fa-circle-exclamation me-2"></i>{{ texts.commentRequired | localize }}
                    </p>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
          }
          @else
          {
          <p class="text-muted" *ngIf="project.Status == 'AnalysisRequested'">
            Das Feedback wurde bereits aufgenommen. Eine neue Analyse wurde beantragt und wird gerade erstellt.
          </p>

          <p class="text-muted" *ngIf="project.Status != 'AnalysisRequested' ">
            Die Aufnahme von Feedback zu den Referenzprofilen ist abgeschlossen.
          </p>
          }

          <sc-activity-feed #feed [readOnly]="true" [scAnchorTarget]="'Aktivitäten'" [user]="userService.me"
            uri="projects/{{project.Id}}/candidates/{{candidate.Id}}/activities" [mentionsUri]="mentionsUri"
            [condensed]="false" [language]="loc.language" context="project-candidate"
            (itemsChanged)="candidate.feedActivities = $event">
            <ng-template let-activity="activity" let-context="context">
              <sc-activity-item [activity]="activity" [condensed]="false" [showProjectName]="true"
                [language]="loc.language" [context]="context"></sc-activity-item>
            </ng-template>
          </sc-activity-feed>
          }
        </div>
      </div>

    </sc-modal-body>

    <sc-modal-footer>
      <div class="row w-100 align-items-center">

        <div class="col-auto">
          <button class="btn btn-secondary btn-circle me-2" (click)="previousReview(i)" [disabled]="isFirst"
            [title]="texts.previous | localize" [attr.aria-label]="texts.previous | localize">
            <i class="fa-sharp fa-solid fa-chevron-left"></i>
          </button>

          <button class="btn btn-secondary btn-circle" (click)="nextReview(i)" [disabled]="isLast && !canReview()"
            [title]="texts.next | localize" [attr.aria-label]="texts.next | localize">
            <i class="fa-sharp fa-solid fa-chevron-right"></i>
          </button>
        </div>

        <div class="col text-center small text-muted">
          {{ texts.reviewPagePrefix | localize }} {{ i + 1 }} {{ texts.reviewPageOf | localize }} {{ candidates.length }}
        </div>

        @if (canReview()) {
        <div class="col-auto">
          <button class="btn btn-dark me-2" (click)="rejectReference(candidate, i)">
              <i class="fa-sharp fa-solid fa-xmark me-2"></i> {{ texts.noMatch | localize }}
            </button>

            <button class="btn btn-dark me-2" (click)="acceptReference(candidate, i)">
              <i class="fa-sharp fa-solid fa-check me-2"></i> {{ texts.match | localize }}
            </button>
        </div>
        }

      </div>
    </sc-modal-footer>

  </sc-modal-wizard-page>

  <sc-modal-wizard-page #reviewConfirmation>
    <sc-modal-body>
      <div class="row h-100 align-items-center">
        <div class="col-6 offset-3 text-center">

          <p class="h4 mb-4" [innerHTML]="texts.reviewThankYou | localize">
          </p>

          <p class="mb-6">{{ texts.reviewThankYouFollowUp | localize }}</p>

          <div>
            <button class="btn btn-lg btn-secondary me-3" [class.loading]="isRequestingNewAnalysis"
              (click)="requestNewAnalysis(requestAnalysisConfirmation)">
              {{ texts.requestNewAnalysis | localize }}
            </button>

            <button class="btn btn-lg btn-dark" (click)="reviewModal.dismiss(); startModal.show(project); ">
              <i class="fa-sharp fa-solid fa-arrow-right me-2"></i>{{ texts.startSourcing | localize }}
            </button>
          </div>
        </div>

      </div>
    </sc-modal-body>
  </sc-modal-wizard-page>

  <sc-modal-wizard-page #requestAnalysisConfirmation>
    <sc-modal-body>
      <div class="row h-100 align-items-center">
        <div class="col-8 offset-2 text-center">

          <p class="h4 mb-6" [innerHTML]="texts.newAnalysisRequestedThankYou | localize">
          </p>

          <div>

            <button class="btn btn-lg btn-secondary" (click)="reviewModal.dismiss();">
              {{ texts.close | localize }}
            </button>
          </div>
        </div>

      </div>
    </sc-modal-body>
  </sc-modal-wizard-page>

  <sc-modal-wizard-page #analysisAlreadyRequestedConfirmation>
    <sc-modal-body>
      <div class="row h-100 align-items-center">
        <div class="col-8 offset-2 text-center">

          <p class="h4 mb-6" [innerHTML]="texts.newAnalysisRequestedThankYou | localize">
          </p>

          <div>

            <button class="btn btn-lg btn-secondary" (click)="reviewModal.dismiss();">
              {{ texts.close | localize }}
            </button>
          </div>
        </div>

      </div>
    </sc-modal-body>
  </sc-modal-wizard-page>

</sc-modal-wizard>